import React from 'react'

import { Loader } from '../loader/Loader'
import { ErrorView } from '../errorView/ErrorView'
import { PercentButton } from '../percentButton/PercentButton'

import { Box, Typography } from '@percent/lemonade'
import style from './DialogDeleteBody.module.scss'
import { DialogDeleteBodyProps } from './DialogDeleteBody.types'

export function DialogDeleteBody({
  bodyText,
  errorMessage,
  handleSubmit,
  testId,
  buttonTitle,
  isLoading
}: DialogDeleteBodyProps) {
  return (
    <Box className={style.dialogMargin}>
      <Typography variant="large" className={style.bodyText}>
        {bodyText}
      </Typography>
      <Box>
        {isLoading && <Loader />}
        {errorMessage && <ErrorView errorMessage={errorMessage} />}
        <PercentButton onClick={handleSubmit} testId={testId} title={buttonTitle} className={style.activeButton} />
      </Box>
    </Box>
  )
}
